import React from 'react'
import { List, Card, Button } from 'antd';

class ViewPricing extends React.Component {

    state = {
        data: [
            {
                title: 'Title 1',
                content: [
                    {
                        price: '100元',
                        space: '台南',
                        user: '一般人',
                        support: '汽車一輛',
                        backup: '支援',
                        access: 'salfjasfas'
                    }
                ]
            },
            {
                title: 'Title 2',
                content: [
                    {
                        price: '100元',
                        space: '台南',
                        user: '一般人',
                        support: '汽車一輛',
                        backup: '支援',
                        access: 'salfjasfas'
                    }
                ]
            },
            {
                title: 'Title 3',
                content: [
                    {
                        price: '100元',
                        space: '台南',
                        user: '一般人',
                        support: '汽車一輛',
                        backup: '支援',
                        access: 'salfjasfas'
                    }
                ]
            },
            {
                title: 'Title 4',
                content: [
                    {
                        price: '100元',
                        space: '台南',
                        user: '一般人',
                        support: '汽車一輛',
                        backup: '支援',
                        access: 'salfjasfas'
                    }
                ]
            },
            {
                title: 'Title 5',
                content: [
                    {
                        price: '100元',
                        space: '台南',
                        user: '一般人',
                        support: '汽車一輛',
                        backup: '支援',
                        access: 'salfjasfas'
                    }
                ]
            },
        ]
    }

    render() {
        const { data } = this.state
        return (
            <div id="pricing" className="block pricingBlock bgGray">
                <div className="container-fluid">
                    <div className="titleHolder">
                        <h2>您將了解以下問題</h2>
                        <span>建立證照地圖，詳細陳列證照與課程學習關聯圖，能有效引導學生學習方向</span>
                    </div>
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 5,
                            lg: 5,
                            xl: 5,
                            xxl: 5
                        }}
                        dataSource={data}
                        renderItem={item => (
                            <List.Item>
                                <Card title={item.title}>
                                    <p><span className="large">{item.content[0].price}</span></p>
                                    <p>{item.content[0].space}</p>
                                    <p>{item.content[0].user}</p>
                                    <p>{item.content[0].support}</p>
                                    <p>{item.content[0].backup}</p>
                                    <p>{item.content[0].access}</p>
                                    <Button type="primary" style={{ background: "red", borderColor: "yellow" }} size="large">Submit</Button>
                                </Card>
                            </List.Item>
                        )}
                    />
                </div>
            </div>
        )
    }
}

export default ViewPricing